import './DatasetDetailsTabs.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { S_Tab } from '../../../../design/tabs/tab/S_Tab';
import { S_TabsContainer } from '../../../../design/tabs/tabsContainer/S_TabsContainer';
import { SpaceBetweenLayout } from '../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { Home } from '../../../routes/config/Home';
import { DatasetDetailsImageListControlsContainer } from '../containers/DatasetDetailsImageListControls.container';
import { IDatasetDetails } from '../datasetsDetails.store';

interface IProps {
  workspaceId: string;
  details: IDatasetDetails;
  imageClickCallback: () => void;
}

interface ITabProps {
  link: string;
  label: string;
  active: boolean;
  callback?: () => void;
}

export const DatasetDetailsTabs = observer((props: IProps): ReactElement => {
  const { details, workspaceId, imageClickCallback } = props;
  const { t } = useTranslator();
  const { pathname } = useLocation();

  const Tab = ({ link, label, active, callback }: ITabProps): ReactElement => (
    <S_Tab
      text={label}
      link={Home.Datasets.Details.Paths.withParams({ datasetId: details.id, tab: link, workspaceId: workspaceId })}
      state={active ? 'active' : 'passive'}
      callback={callback}
    />
  );

  return (
    <div>
      <div className='actions-comment'>
        <Trans
          i18nKey={
            details.status === 'Published' || details.status === 'PublishedUploading'
              ? t('this_dataset_has_been_published')
              : t('dataset_must_be_published_warning_long')
          }
          components={{ b: <b /> }}
        />
      </div>

      <SpaceBetweenLayout>
        <S_TabsContainer>
          <Tab
            link='images'
            label={`${t('images')} (${details.imagesCount})`}
            active={pathname.includes('images')}
            callback={imageClickCallback}
          />
          <Tab
            link='projects'
            label={`${t('projects_header')} (${details.projectsCount})`}
            active={pathname.includes('projects')}
          />
        </S_TabsContainer>
        {window.location.pathname.includes('images') && <DatasetDetailsImageListControlsContainer />}
      </SpaceBetweenLayout>
    </div>
  );
});
